import { inject as i, computed as n } from "vue";
import { configProviderInjectionKey as d } from "./highrise1066.mjs";
import u from "./highrise624.mjs";
import c from "./highrise625.mjs";
function L(t) {
  const {
    mergedLocaleRef: o,
    mergedDateLocaleRef: l
  } = i(d, null) || {}, a = n(() => {
    var e, r;
    return (r = (e = o == null ? void 0 : o.value) === null || e === void 0 ? void 0 : e[t]) !== null && r !== void 0 ? r : u[t];
  });
  return {
    dateLocaleRef: n(() => {
      var e;
      return (e = l == null ? void 0 : l.value) !== null && e !== void 0 ? e : c;
    }),
    localeRef: a
  };
}
export {
  L as default
};
